import styled from 'styled-components';

export const FlowerContainer = styled.div`
  width: 100%;
  background-color: red;
  justify-content: center;
  display: flex;
  align-items: self-end;
  cursor:pointer;
  animation: scale-up-center 2s ;
  @keyframes scale-up-center{0%{transform:scale(.2)}100%{transform:scale(1)}}
`
